const MILLISECONDS_MULTIPLIER = 1000;

export const TRANSITION_END = 'transitionend';

export const isElement = (obj) => {
	if (!obj || typeof obj !== 'object') {
		return false;
	}

	return typeof obj.nodeType !== 'undefined';
};

export const getElement = (obj) => {
	// it's a node element
	if (isElement(obj)) {
		return obj;
	}

	if (typeof obj === 'string' && obj.length > 0) {
		return document.querySelector(obj);
	}

	return null;
};

/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @returns void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */
export const reflow = (element) => {
	element.offsetHeight;
};

export const execute = (callback) => {
	if (typeof callback === 'function') {
		callback();
	}
};

export const triggerTransitionEnd = (element) => {
	element.dispatchEvent(new Event(TRANSITION_END));
};

export const emulateTransitionEnd = (element, duration) => {
	let called = false;
	const durationPadding = 5;
	const emulatedDuration = duration + durationPadding;

	function listener() {
		called = true;
		element.removeEventListener(TRANSITION_END, listener);
	}

	element.addEventListener(TRANSITION_END, listener);
	setTimeout(() => {
		if (!called) {
			triggerTransitionEnd(element);
		}
	}, emulatedDuration);
};

export const getTransitionDurationFromElement = (element) => {
	if (!element) {
		return 0;
	}

	// Get transition-duration of the element
	let { transitionDuration, transitionDelay } = window.getComputedStyle(element);

	const floatTransitionDuration = Number.parseFloat(transitionDuration);
	const floatTransitionDelay = Number.parseFloat(transitionDelay);

	// Return 0 if element or transition duration is not found
	if (!floatTransitionDuration && !floatTransitionDelay) {
		return 0;
	}

	// If multiple durations are defined, take the first
	transitionDuration = transitionDuration.split(',')[0];
	transitionDelay = transitionDelay.split(',')[0];

	return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};

export const executeAfterTransition = (callback, transitionElement, waitForTransition = true) => {
	if (!waitForTransition) {
		execute(callback);
		return;
	}

	const durationPadding = 5;
	const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;

	let called = false;

	const handler = ({ target }) => {
		if (target !== transitionElement) {
			return;
		}

		called = true;
		transitionElement.removeEventListener(TRANSITION_END, handler);
		execute(callback);
	};

	transitionElement.addEventListener(TRANSITION_END, handler);
	setTimeout(() => {
		if (!called) {
			triggerTransitionEnd(transitionElement);
		}
	}, emulatedDuration);
};
